import throttle from 'lodash.throttle';
import type { ElementPositionPayload } from '~/types/elementPositionPayload';
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('detectPosition', {
    mounted (el, binding) {
      if (!binding?.value) { return; }
      const handleScroll = () => {
        const dfpAdChild = (el as HTMLElement).querySelector<HTMLElement>(':scope > .dfp-ad > div');
        if (dfpAdChild && getComputedStyle(dfpAdChild).display === 'none') { return; }
        const iframes = (el as HTMLElement).querySelectorAll<HTMLIFrameElement>('iframe');
        const iframe = Array.from(iframes).find(f => f.offsetWidth > 0 || f.offsetHeight > 0) ?? null;
        const rect = (iframe ?? el).getBoundingClientRect();
        let payload: ElementPositionPayload = { element: el, position: rect, isIntersecting: currentIntersecting };
        payload = { ...payload, ...binding?.value };
        useBusEmitter('element-position', payload);
      };
      const throttleHandleScroll = throttle(handleScroll, 200);
      let currentIntersecting = false;
      useIntersectionObserver(
        el,
        ([{ isIntersecting }]) => {
          currentIntersecting = isIntersecting;
          if (isIntersecting) {
            window.addEventListener('scroll', throttleHandleScroll);
          } else {
            window.removeEventListener('scroll', throttleHandleScroll);
          }
        },
        {
          root: null,
          rootMargin: '0px'
        }
      );
    }
  });
});
